enum SubscriptionPlan {
  GO = "nuve_go",
  BASIC = "nuve_basic",
  PLUS = "nuve_plus",
  NETWORK = "nuve_network",
  CONNECT = "nuve_connect",
  SUPREME = "nuve_supreme",
  BASIC_OCT_2025 = "nuve_basic_oct_2025",
  BASIC_MAY_2025 = "nuve_basic_may_2025",
  BASIC_DEC_2025 = "nuve_basic_dec_2025",
  E_PLUS = "nuve_e_plus",
  GROWTH = "nuve_growth",
  GROW_MARCH_2026 = "nuve_grow_march_2026",
  START = "nuve_start",
  BASIC_MAY_2026 = "nuve_basic_may_2026",
  NETWORK_JULY_2026 = "nuve_network_july_2026",
  BASIC_JULY_2026 = "nuve_basic_july_2026",
}

export default SubscriptionPlan
